export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const WEBSITE_URL = process.env.WEBSITE_URL;
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = BASE_URL + '/storage/images/';
export const MAP_API_KEY = process.env.MAP_API_KEY;
export const VAPID_KEY = process.env.VAPID_KEY;